// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ——— Experiments page (list + detail) ——— */
.experiments-page {
    padding: 0 clamp(16px, 3vw, 28px) clamp(24px, 4vw, 40px);
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
}

.experiments-page__title {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0;
    font-size: clamp(1.1rem, 2.5vw, 1.35rem);
    font-weight: 650;
    letter-spacing: -0.02em;
    color: #f0f0f0;
}

.experiments-page__title-icon {
    flex-shrink: 0;
    opacity: 0.92;
    filter: drop-shadow(0 0 10px rgba(192, 159, 83, 0.25));
}

.experiments-loading,
.experiments-error,
.experiments-empty {
    color: rgba(180, 180, 180, 0.95);
    margin-top: 18px;
    font-size: 0.9375rem;
}

.experiments-empty {
    margin-top: 24px;
    text-align: center;
    font-weight: 500;
    line-height: 1.55;
    padding: 28px 20px;
    border: 1px solid rgba(255, 255, 255, 0.09);
    border-radius: 14px;
    background: rgba(0, 0, 0, 0.2);
    max-width: 520px;
    margin-left: auto;
    margin-right: auto;
}

.experiments-error {
    color: #e8a0a0;
}

.experiments-list {
    margin-top: 20px;
}

.experiments-list-intro {
    color: rgba(165, 165, 165, 0.95);
    margin-bottom: 16px;
    font-size: 0.9375rem;
    line-height: 1.5;
    max-width: 42em;
}

.experiments-id-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-width: 480px;
}

.experiments-id-link {
    display: block;
    padding: 14px 18px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: linear-gradient(165deg, rgba(52, 52, 56, 0.45) 0%, rgba(24, 24, 28, 0.65) 100%);
    color: #e8dcc8;
    text-decoration: none;
    font-weight: 600;
    font-size: 0.9rem;
    font-family: ui-monospace, "SF Mono", Menlo, monospace;
    transition:
        border-color 0.2s ease,
        background 0.2s ease,
        transform 0.15s ease;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.experiments-id-link:hover {
    border-color: rgba(192, 159, 83, 0.45);
    background: linear-gradient(165deg, rgba(72, 68, 58, 0.55) 0%, rgba(32, 30, 26, 0.75) 100%);
    color: #faf6ee;
}

.experiments-id-link:active {
    transform: translateY(1px);
}

.experiments-back {
    margin-left: 10px;
    padding: 8px 14px;
    font-size: 0.8125rem;
    font-weight: 600;
    font-family: inherit;
    color: #c8c8c8;
    background: rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 10px;
    cursor: pointer;
    transition:
        color 0.2s ease,
        border-color 0.2s ease,
        background 0.2s ease;
}

.experiments-back:hover {
    color: #f0f0f0;
    border-color: rgba(192, 159, 83, 0.4);
    background: rgba(192, 159, 83, 0.08);
}

.experiments-back:focus-visible {
    outline: 2px solid rgba(192, 159, 83, 0.55);
    outline-offset: 2px;
}

/* ——— Variant grid ——— */
.experiments-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 380px), 1fr));
    gap: clamp(18px, 3vw, 26px);
    margin-top: 8px;
}

/* ——— Single variant card ——— */
.experiment-card {
    position: relative;
    border-radius: 16px;
    padding: clamp(18px, 3vw, 24px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: linear-gradient(168deg, rgba(52, 52, 56, 0.55) 0%, rgba(22, 22, 26, 0.92) 100%);
    box-shadow:
        0 20px 48px rgba(0, 0, 0, 0.35),
        inset 0 1px 0 rgba(255, 255, 255, 0.05);
    color: rgba(200, 200, 200, 0.98);
    display: flex;
    flex-direction: column;
    gap: 20px;
    overflow: hidden;
}

.experiment-card::before {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 38%;
    max-width: 160px;
    height: 3px;
    border-radius: 0 0 10px 10px;
    background: linear-gradient(90deg, transparent, rgba(192, 159, 83, 0.75), transparent);
    pointer-events: none;
    opacity: 0.85;
}

.experiment-card--winning {
    border-color: rgba(192, 159, 83, 0.42);
    box-shadow:
        0 0 0 1px rgba(192, 159, 83, 0.12),
        0 22px 56px rgba(0, 0, 0, 0.42),
        inset 0 1px 0 rgba(255, 255, 255, 0.06);
}

.experiment-card--winning::before {
    opacity: 1;
    width: 48%;
    max-width: 200px;
    background: linear-gradient(90deg, transparent, rgba(192, 159, 83, 0.95), transparent);
}

.experiment-card__header {
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding-bottom: 4px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
}

.experiment-card__title-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px 14px;
}

.experiment-card__variant {
    margin: 0;
    font-size: clamp(1.05rem, 2.4vw, 1.35rem);
    font-weight: 650;
    letter-spacing: -0.02em;
    color: #f4f4f4;
    line-height: 1.25;
    word-break: break-word;
}

.experiment-card__winning-badge {
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #faf6ee;
    padding: 6px 12px;
    border-radius: 999px;
    border: 1px solid rgba(192, 159, 83, 0.5);
    background: linear-gradient(180deg, rgba(192, 159, 83, 0.32) 0%, rgba(140, 115, 60, 0.22) 100%);
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
}

.experiment-card__meta {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.experiment-card__chip {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    padding: 10px 14px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.09);
    background: rgba(0, 0, 0, 0.28);
    font-size: 0.8125rem;
    line-height: 1.35;
    color: #dcdcdc;
    max-width: 100%;
    word-break: break-word;
}

.experiment-card__chip-key {
    font-size: 0.625rem;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: rgba(192, 159, 83, 0.92);
}

/* ——— Chart row ——— */
.experiment-card__charts {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
}

.experiment-card__chart-panel {
    padding: 14px 12px 16px;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(0, 0, 0, 0.22);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    min-width: 0;
}

.experiment-card__chart-inner {
    width: 124px;
    height: 124px;
    position: relative;
    margin: 0 auto 4px;
}

.experiment-card__chart-inner canvas {
    max-width: 100% !important;
    max-height: 100% !important;
}

.experiment-card__chart-caption {
    font-size: 0.6875rem;
    font-weight: 700;
    letter-spacing: 0.11em;
    text-transform: uppercase;
    color: rgba(192, 159, 83, 0.95);
    margin-top: 4px;
}

.experiment-card__chart-hint {
    font-size: 0.6875rem;
    color: rgba(150, 150, 150, 0.9);
    margin-top: 4px;
    line-height: 1.35;
    max-width: 11rem;
}

/* ——— Metrics ——— */
.experiment-card__metrics-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px 20px;
}

.experiment-card__section {
    min-width: 0;
    padding: 14px 14px 12px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.06);
    background: rgba(0, 0, 0, 0.15);
}

.experiment-card__section-title {
    margin: 0 0 12px;
    font-size: 0.625rem;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: rgba(192, 159, 83, 0.92);
}

.experiment-card__metrics {
    list-style: none;
    margin: 0;
    padding: 0;
}

.experiment-card__metrics li {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 12px;
    padding: 8px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    font-size: 0.8125rem;
}

.experiment-card__metrics li:last-child {
    border-bottom: none;
    padding-bottom: 0;
}

.experiment-card__metrics .metric-label {
    color: rgba(165, 165, 165, 0.98);
    flex: 1;
    min-width: 0;
}

.experiment-card__metrics .metric-value {
    font-weight: 650;
    font-variant-numeric: tabular-nums;
    color: #ececec;
    text-align: right;
    flex-shrink: 0;
}

.experiments-filters {
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: flex-end;
}

/* ——— Channel filter bar (above the variant grid) ——— */
.experiments-filter-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px 16px;
    margin: 0 0 18px;
    padding: 12px 16px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(0, 0, 0, 0.22);
}

.experiments-filter-bar__label {
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: rgba(192, 159, 83, 0.92);
    flex-shrink: 0;
}

.experiments-filter-bar__chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px 8px;
    flex: 1 1 auto;
    min-width: 0;
}

.experiments-filter-chip {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    font-size: 0.8rem;
    font-weight: 600;
    font-family: inherit;
    color: rgba(220, 220, 230, 0.92);
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 999px;
    cursor: pointer;
    transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;
}

.experiments-filter-chip:hover,
.experiments-filter-chip:focus-visible {
    color: #faf6ee;
    border-color: rgba(192, 159, 83, 0.45);
    background: rgba(192, 159, 83, 0.08);
}

.experiments-filter-chip:focus-visible {
    outline: 2px solid rgba(192, 159, 83, 0.55);
    outline-offset: 2px;
}

.experiments-filter-chip.is-active {
    color: #20180c;
    background: linear-gradient(
        165deg,
        rgba(216, 181, 106, 0.96) 0%,
        rgba(184, 141, 60, 0.96) 100%
    );
    border-color: rgba(192, 159, 83, 0.55);
}

.experiments-filter-chip.is-active .experiments-filter-chip__count {
    color: rgba(20, 18, 12, 0.78);
    background: rgba(0, 0, 0, 0.18);
    border-color: rgba(0, 0, 0, 0.18);
}

.experiments-filter-chip--untargeted:not(.is-active) {
    color: rgba(180, 180, 190, 0.86);
    border-style: dashed;
}

.experiments-filter-chip__count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 1.5em;
    padding: 1px 7px;
    font-size: 0.7rem;
    font-weight: 700;
    color: rgba(220, 220, 230, 0.92);
    background: rgba(0, 0, 0, 0.32);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 999px;
    font-variant-numeric: tabular-nums;
}

/* ——— Audience chip on variant cards ——— */
.experiment-card__chip--channel .experiment-card__chip-key {
    color: rgba(190, 220, 245, 0.92);
}

.experiment-card__chip--channel {
    border-color: rgba(130, 175, 220, 0.32);
    background: rgba(130, 175, 220, 0.08);
}

@media screen and (max-width: 640px) {
    .experiment-card__charts {
        grid-template-columns: 1fr;
    }

    .experiment-card__metrics-grid {
        grid-template-columns: 1fr;
    }
}

@media screen and (max-width: 900px) {
    .experiments-grid {
        grid-template-columns: 1fr;
    }
}

/* ——— List actions row (intro + create button) ——— */
.experiments-list-actions {
    display: flex;
    flex-wrap: wrap;
    /*
     * Center-align so the intro copy sits at the same vertical
     * midpoint as the (taller, padded) "Create experiment" button.
     * Using flex-start let the paragraph baseline ride up to the top
     * of the row while the button's label centered inside its
     * padding, which read as the intro being "too high".
     */
    align-items: center;
    justify-content: space-between;
    gap: 14px 18px;
    margin-bottom: 18px;
}

.experiments-list-actions .experiments-list-intro {
    /*
     * <p> defaults to 1em top + bottom margin which would push the
     * intro down inside its intro-block flex column and add a stray
     * gap above the optional domain pill. Reset both — the intro-
     * block already provides spacing via its own \`gap\`.
     */
    margin: 0;
}

.experiments-create-toggle {
    flex-shrink: 0;
    padding: 10px 18px;
    font-size: 0.84rem;
    font-weight: 650;
    font-family: inherit;
    color: #20180c;
    background: linear-gradient(
        165deg,
        rgba(216, 181, 106, 0.96) 0%,
        rgba(184, 141, 60, 0.96) 100%
    );
    border: 1px solid rgba(192, 159, 83, 0.55);
    border-radius: 10px;
    cursor: pointer;
    transition: filter 0.15s ease, transform 0.15s ease;
}

.experiments-create-toggle:hover {
    filter: brightness(1.07);
}

.experiments-create-toggle:focus-visible {
    outline: 2px solid rgba(192, 159, 83, 0.6);
    outline-offset: 2px;
}

.experiments-create-toggle:active {
    transform: translateY(1px);
}

.experiments-create-toggle[aria-expanded="true"] {
    color: #e8dcc8;
    background: rgba(0, 0, 0, 0.25);
    border-color: rgba(255, 255, 255, 0.14);
}

/* ——— Experiment builder panel ——— */
.experiment-builder {
    position: relative;
    margin: 0 0 28px;
    padding: clamp(20px, 3vw, 28px);
    border-radius: 16px;
    border: 1px solid rgba(192, 159, 83, 0.22);
    background: linear-gradient(
        168deg,
        rgba(54, 48, 32, 0.42) 0%,
        rgba(22, 22, 26, 0.92) 100%
    );
    box-shadow:
        0 18px 44px rgba(0, 0, 0, 0.32),
        inset 0 1px 0 rgba(255, 255, 255, 0.04);
    color: rgba(220, 220, 220, 0.96);
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
}

.experiment-builder__head {
    position: relative;
    margin: 0 0 22px;
    padding-bottom: 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
}

.experiment-builder__title {
    margin: 0 0 6px;
    font-size: clamp(1.05rem, 2.2vw, 1.25rem);
    font-weight: 650;
    letter-spacing: -0.01em;
    color: #faf6ee;
}

.experiment-builder__intro {
    margin: 0;
    font-size: 0.86rem;
    line-height: 1.55;
    color: rgba(180, 180, 185, 0.92);
    max-width: 56rem;
}

.experiment-builder__intro code {
    padding: 1px 6px;
    font-size: 0.78rem;
    color: rgba(232, 220, 200, 0.95);
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 4px;
}

.experiment-builder__close {
    position: absolute;
    top: -4px;
    right: -4px;
    width: 32px;
    height: 32px;
    padding: 0;
    font-size: 1.2rem;
    line-height: 1;
    font-family: inherit;
    color: rgba(200, 200, 210, 0.86);
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 8px;
    cursor: pointer;
    transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;
}

.experiment-builder__close:hover,
.experiment-builder__close:focus-visible {
    color: #f0f0f0;
    border-color: rgba(192, 159, 83, 0.55);
    background: rgba(192, 159, 83, 0.1);
}

.experiment-builder__field,
.experiment-builder__channel,
.experiment-builder__variants,
.experiment-builder__split,
.experiment-builder__output {
    margin-bottom: 20px;
}

/* ——— Audience targeting (channel) section ——— */
.experiment-builder__channel-head {
    margin-bottom: 12px;
}

.experiment-builder__channel-head em {
    font-style: italic;
    color: rgba(220, 220, 230, 0.95);
}

.experiment-builder__channel-controls {
    display: grid;
    gap: 14px;
}

.experiment-builder__channel-detail {
    padding: 14px 16px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.07);
    background: rgba(0, 0, 0, 0.22);
}

.experiment-builder__channel-detail .experiment-builder__hint:first-child {
    margin-top: 0;
}

.experiment-builder__alias-list {
    list-style: none;
    margin: 8px 0 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 6px 8px;
}

.experiment-builder__alias-list li {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    background: rgba(192, 159, 83, 0.1);
    border: 1px solid rgba(192, 159, 83, 0.28);
    border-radius: 999px;
}

.experiment-builder__alias-list code {
    font-size: 0.74rem;
    color: rgba(232, 220, 200, 0.95);
    background: none;
    border: none;
    padding: 0;
}

.experiment-builder__channel-custom {
    display: grid;
    grid-template-columns: minmax(180px, 1fr) minmax(180px, 1fr);
    gap: 12px;
    padding: 14px 16px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.07);
    background: rgba(0, 0, 0, 0.22);
}

.experiment-builder__channel-custom .experiment-builder__variant-field:nth-child(3),
.experiment-builder__channel-custom > .experiment-builder__hint {
    grid-column: 1 / -1;
}

.experiment-builder__input--textarea {
    font-family: ui-monospace, "SF Mono", Menlo, monospace;
    font-size: 0.8rem;
    line-height: 1.5;
    resize: vertical;
    min-height: 48px;
}

@media screen and (max-width: 720px) {
    .experiment-builder__channel-custom {
        grid-template-columns: 1fr;
    }
}

.experiment-builder__label {
    display: block;
    margin-bottom: 6px;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(192, 159, 83, 0.92);
}

.experiment-builder__hint {
    margin: 6px 0 0;
    font-size: 0.78rem;
    line-height: 1.5;
    color: rgba(160, 160, 170, 0.92);
}

.experiment-builder__hint code {
    padding: 1px 5px;
    font-size: 0.72rem;
    color: rgba(220, 220, 230, 0.92);
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 4px;
}

.experiment-builder__input {
    width: 100%;
    padding: 9px 12px;
    font-size: 0.86rem;
    font-family: inherit;
    color: #f0f0f0;
    background: rgba(0, 0, 0, 0.32);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 8px;
    transition: border-color 0.15s ease, background 0.15s ease;
    box-sizing: border-box;
}

.experiment-builder__input:focus {
    outline: none;
    border-color: rgba(192, 159, 83, 0.6);
    background: rgba(0, 0, 0, 0.42);
}

.experiment-builder__input::placeholder {
    color: rgba(160, 160, 170, 0.6);
}

.experiment-builder__subtitle {
    margin: 0 0 8px;
    font-size: 0.95rem;
    font-weight: 650;
    color: #f0f0f0;
}

.experiment-builder__subtitle--small {
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(192, 159, 83, 0.92);
}

.experiment-builder__variants-head {
    margin-bottom: 12px;
}

.experiment-builder__variants-head em {
    font-style: italic;
    color: rgba(220, 220, 230, 0.95);
}

.experiment-builder__variant-list {
    list-style: none;
    margin: 0 0 12px;
    padding: 0;
    display: grid;
    gap: 12px;
}

.experiment-builder__variant {
    padding: 14px 16px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(0, 0, 0, 0.22);
}

.experiment-builder__variant-row {
    display: grid;
    grid-template-columns: minmax(140px, 1fr) 110px 1fr auto;
    gap: 12px;
    align-items: end;
}

.experiment-builder__variant-field {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.experiment-builder__variant-field--narrow {
    max-width: 110px;
}

.experiment-builder__variant-field--color .experiment-builder__color-row {
    display: flex;
    gap: 8px;
    align-items: center;
}

.experiment-builder__variant-field--color .experiment-builder__input {
    flex: 1;
    min-width: 0;
}

.experiment-builder__color-picker {
    flex-shrink: 0;
    width: 38px;
    height: 38px;
    padding: 0;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.32);
    cursor: pointer;
}

.experiment-builder__color-picker::-webkit-color-swatch-wrapper {
    padding: 4px;
}

.experiment-builder__color-picker::-webkit-color-swatch {
    border-radius: 5px;
    border: none;
}

.experiment-builder__field-key {
    margin-bottom: 5px;
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(170, 170, 180, 0.85);
}

.experiment-builder__checkbox {
    grid-column: 1 / -2;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-top: 4px;
    font-size: 0.82rem;
    color: rgba(200, 200, 210, 0.92);
    cursor: pointer;
}

.experiment-builder__checkbox input[type="checkbox"] {
    accent-color: rgba(192, 159, 83, 0.85);
    width: 16px;
    height: 16px;
}

.experiment-builder__remove {
    align-self: end;
    padding: 8px 12px;
    font-size: 0.78rem;
    font-family: inherit;
    color: rgba(220, 180, 180, 0.92);
    background: transparent;
    border: 1px solid rgba(220, 100, 100, 0.32);
    border-radius: 8px;
    cursor: pointer;
    transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;
}

.experiment-builder__remove:hover:not(:disabled),
.experiment-builder__remove:focus-visible:not(:disabled) {
    color: #fbe6e6;
    border-color: rgba(232, 95, 95, 0.65);
    background: rgba(232, 95, 95, 0.12);
}

.experiment-builder__remove:disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

.experiment-builder__variant-settings {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 12px;
    margin-top: 14px;
    padding: 12px 14px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.05);
    background: rgba(0, 0, 0, 0.18);
}

.experiment-builder__add {
    padding: 10px 16px;
    font-size: 0.84rem;
    font-weight: 600;
    font-family: inherit;
    color: rgba(220, 220, 230, 0.92);
    background: rgba(255, 255, 255, 0.04);
    border: 1px dashed rgba(255, 255, 255, 0.18);
    border-radius: 9px;
    cursor: pointer;
    transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;
}

.experiment-builder__add:hover,
.experiment-builder__add:focus-visible {
    color: #faf6ee;
    border-color: rgba(192, 159, 83, 0.5);
    background: rgba(192, 159, 83, 0.08);
}

.experiment-builder__split-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 8px 12px;
}

.experiment-builder__split-list li {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    font-size: 0.78rem;
    color: rgba(220, 220, 230, 0.92);
    background: rgba(0, 0, 0, 0.28);
    border: 1px solid rgba(255, 255, 255, 0.07);
    border-radius: 999px;
}

.experiment-builder__split-list code {
    font-size: 0.78rem;
    color: rgba(232, 220, 200, 0.95);
}

.experiment-builder__split-list span {
    font-variant-numeric: tabular-nums;
    color: rgba(192, 159, 83, 0.92);
    font-weight: 650;
}

.experiment-builder__errors {
    margin-bottom: 16px;
    padding: 12px 16px;
    border-radius: 10px;
    border: 1px solid rgba(232, 95, 95, 0.4);
    background: linear-gradient(
        155deg,
        rgba(232, 95, 95, 0.12) 0%,
        rgba(0, 0, 0, 0.22) 65%
    );
    color: rgba(255, 220, 220, 0.95);
    font-size: 0.82rem;
    line-height: 1.5;
}

.experiment-builder__errors strong {
    display: block;
    margin-bottom: 6px;
    color: rgba(255, 200, 200, 0.96);
}

.experiment-builder__errors ul {
    margin: 0;
    padding-left: 18px;
}

.experiment-builder__output-head {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 8px 14px;
    margin-bottom: 8px;
}

.experiment-builder__copy {
    padding: 8px 16px;
    font-size: 0.82rem;
    font-weight: 650;
    font-family: inherit;
    color: #20180c;
    background: linear-gradient(
        165deg,
        rgba(216, 181, 106, 0.96) 0%,
        rgba(184, 141, 60, 0.96) 100%
    );
    border: 1px solid rgba(192, 159, 83, 0.55);
    border-radius: 9px;
    cursor: pointer;
    transition: filter 0.15s ease;
}

.experiment-builder__copy:hover:not(:disabled),
.experiment-builder__copy:focus-visible:not(:disabled) {
    filter: brightness(1.07);
}

.experiment-builder__copy:disabled {
    opacity: 0.45;
    cursor: not-allowed;
}

.experiment-builder__copy--ok {
    color: #1a3a1a;
    background: linear-gradient(165deg, #a8d39c, #6fae62);
    border-color: rgba(150, 200, 130, 0.6);
}

.experiment-builder__copy--err {
    color: #fbe6e6;
    background: linear-gradient(165deg, rgba(232, 95, 95, 0.85), rgba(180, 60, 60, 0.85));
    border-color: rgba(232, 95, 95, 0.55);
}

.experiment-builder__snippet {
    margin: 0;
    padding: 16px 18px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(0, 0, 0, 0.42);
    color: #e8dcc8;
    font-family: ui-monospace, "SF Mono", Menlo, monospace;
    font-size: 0.78rem;
    line-height: 1.6;
    white-space: pre;
    overflow-x: auto;
    max-height: 360px;
    overflow-y: auto;
}

.experiment-builder__snippet code {
    background: none;
    border: none;
    padding: 0;
    color: inherit;
    font-size: inherit;
}

@media screen and (max-width: 720px) {
    .experiment-builder__variant-row {
        grid-template-columns: 1fr 1fr;
    }

    .experiment-builder__variant-row .experiment-builder__variant-field--narrow {
        max-width: none;
    }

    .experiment-builder__checkbox {
        grid-column: 1 / -1;
    }

    .experiment-builder__remove {
        grid-column: 1 / -1;
        justify-self: start;
    }
}

/* ---------------------------------------------------------------- */
/* Experiment summary strip                                         */
/* ---------------------------------------------------------------- */

.experiment-summary {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 18px;
    padding: 18px 22px;
    margin: 0 0 18px;
    background: linear-gradient(
        180deg,
        rgba(192, 159, 83, 0.08) 0%,
        rgba(22, 22, 26, 0.3) 100%
    );
    border: 1px solid rgba(192, 159, 83, 0.22);
    border-radius: 12px;
}

.experiment-summary__cell {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
}

.experiment-summary__label {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: rgba(192, 159, 83, 0.85);
    font-weight: 600;
}

.experiment-summary__value {
    font-size: 22px;
    font-weight: 700;
    color: #f3f3f3;
    line-height: 1.15;
    letter-spacing: -0.01em;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.experiment-summary__value--leader {
    color: #f5d27a;
}

.experiment-summary__sub {
    font-size: 12px;
    color: #a4a4a8;
    line-height: 1.35;
}

.experiment-summary__cell--leader {
    border-left: 1px solid rgba(192, 159, 83, 0.18);
    padding-left: 18px;
}

.experiment-summary__confidence {
    margin-top: 6px;
    align-self: flex-start;
    display: inline-flex;
    align-items: center;
    padding: 3px 8px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.02em;
}

.experiment-summary__confidence--high {
    background: rgba(76, 175, 80, 0.18);
    color: #8de08e;
    border: 1px solid rgba(76, 175, 80, 0.4);
}

.experiment-summary__confidence--mid {
    background: rgba(255, 152, 0, 0.18);
    color: #ffc97a;
    border: 1px solid rgba(255, 152, 0, 0.4);
}

.experiment-summary__confidence--low {
    background: rgba(158, 158, 158, 0.18);
    color: #c4c4c4;
    border: 1px solid rgba(158, 158, 158, 0.35);
}

@media screen and (max-width: 720px) {
    .experiment-summary {
        padding: 14px 16px;
    }

    .experiment-summary__value {
        font-size: 19px;
    }

    .experiment-summary__cell--leader {
        border-left: none;
        padding-left: 0;
        border-top: 1px solid rgba(192, 159, 83, 0.18);
        padding-top: 12px;
    }
}

/* ---------------------------------------------------------------- */
/* Sort + view toolbar                                              */
/* ---------------------------------------------------------------- */

.experiments-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    margin: 0 0 14px;
    padding: 10px 14px;
    background: rgba(22, 22, 26, 0.55);
    border: 1px solid rgba(192, 159, 83, 0.14);
    border-radius: 10px;
}

.experiments-toolbar__field {
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

.experiments-toolbar__label {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: rgba(192, 159, 83, 0.85);
    font-weight: 600;
}

.experiments-toolbar__select {
    background: rgba(34, 34, 40, 0.95);
    color: #ececec;
    border: 1px solid rgba(192, 159, 83, 0.25);
    border-radius: 6px;
    padding: 6px 10px;
    font-size: 13px;
    cursor: pointer;
    transition: border-color 0.15s ease;
}

.experiments-toolbar__select:hover,
.experiments-toolbar__select:focus {
    border-color: rgba(192, 159, 83, 0.55);
    outline: none;
}

.experiments-toolbar__view {
    display: inline-flex;
    border: 1px solid rgba(192, 159, 83, 0.25);
    border-radius: 6px;
    overflow: hidden;
}

.experiments-toolbar__view-btn {
    appearance: none;
    background: rgba(34, 34, 40, 0.6);
    color: #c4c4c4;
    border: none;
    padding: 6px 14px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.02em;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease;
}

.experiments-toolbar__view-btn:not(:last-child) {
    border-right: 1px solid rgba(192, 159, 83, 0.25);
}

.experiments-toolbar__view-btn.is-active {
    background: rgba(192, 159, 83, 0.22);
    color: #f5d27a;
}

.experiments-toolbar__view-btn:not(.is-active):hover {
    background: rgba(192, 159, 83, 0.1);
    color: #ececec;
}

/* ---------------------------------------------------------------- */
/* Lift chip + confidence badge on variant cards                    */
/* ---------------------------------------------------------------- */

.experiment-card__control-badge {
    display: inline-flex;
    align-items: center;
    padding: 3px 9px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    background: rgba(96, 125, 139, 0.22);
    color: #c2d1d9;
    border: 1px solid rgba(96, 125, 139, 0.45);
}

.experiment-card__lift-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 6px;
}

.experiment-card__lift {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.01em;
}

.experiment-card__lift--up {
    background: rgba(76, 175, 80, 0.18);
    color: #8de08e;
    border: 1px solid rgba(76, 175, 80, 0.4);
}

.experiment-card__lift--down {
    background: rgba(244, 67, 54, 0.18);
    color: #ff8a80;
    border: 1px solid rgba(244, 67, 54, 0.4);
}

.experiment-card__lift--flat {
    background: rgba(158, 158, 158, 0.18);
    color: #c4c4c4;
    border: 1px solid rgba(158, 158, 158, 0.35);
}

.experiment-card__confidence {
    display: inline-flex;
    align-items: center;
    padding: 3px 9px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.02em;
}

.experiment-card__confidence--win {
    background: rgba(76, 175, 80, 0.14);
    color: #8de08e;
    border: 1px solid rgba(76, 175, 80, 0.3);
}

.experiment-card__confidence--loss {
    background: rgba(244, 67, 54, 0.14);
    color: #ff8a80;
    border: 1px solid rgba(244, 67, 54, 0.3);
}

.experiment-card__confidence--warn {
    background: rgba(255, 152, 0, 0.14);
    color: #ffc97a;
    border: 1px solid rgba(255, 152, 0, 0.3);
}

.experiment-card__confidence--soft {
    background: rgba(120, 144, 156, 0.18);
    color: #b0bec5;
    border: 1px solid rgba(120, 144, 156, 0.32);
}

.experiment-card__confidence--neutral {
    background: rgba(158, 158, 158, 0.14);
    color: #c4c4c4;
    border: 1px solid rgba(158, 158, 158, 0.3);
}

/* ---------------------------------------------------------------- */
/* Compact table view                                               */
/* ---------------------------------------------------------------- */

.experiments-compact {
    overflow-x: auto;
    background: rgba(22, 22, 26, 0.55);
    border: 1px solid rgba(192, 159, 83, 0.14);
    border-radius: 10px;
    padding: 4px;
}

.experiments-compact__table {
    width: 100%;
    border-collapse: collapse;
    color: #ececec;
    font-size: 13px;
    min-width: 760px;
}

.experiments-compact__table thead th {
    text-align: left;
    padding: 10px 12px;
    font-weight: 600;
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(192, 159, 83, 0.85);
    border-bottom: 1px solid rgba(192, 159, 83, 0.18);
    white-space: nowrap;
}

.experiments-compact__table tbody td {
    padding: 12px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    vertical-align: middle;
}

.experiments-compact__table tbody tr:last-child td {
    border-bottom: none;
}

.experiments-compact__table tbody tr:hover {
    background: rgba(192, 159, 83, 0.06);
}

.experiments-compact__num {
    text-align: right;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
}

.experiments-compact__variant-name {
    font-weight: 600;
    color: #f3f3f3;
}

.experiments-compact__tag {
    display: inline-block;
    margin-left: 8px;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    font-weight: 600;
    background: rgba(96, 125, 139, 0.22);
    color: #c2d1d9;
    border: 1px solid rgba(96, 125, 139, 0.4);
}

.experiments-compact__tag--winning {
    background: rgba(192, 159, 83, 0.22);
    color: #f5d27a;
    border-color: rgba(192, 159, 83, 0.5);
}

.experiments-compact__row--control td {
    background: rgba(96, 125, 139, 0.06);
}

.experiments-compact__row--winning td {
    background: rgba(192, 159, 83, 0.07);
}

.experiments-compact__sig {
    display: inline-flex;
    align-items: center;
    padding: 3px 9px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.02em;
    background: rgba(158, 158, 158, 0.14);
    color: #c4c4c4;
    border: 1px solid rgba(158, 158, 158, 0.3);
    white-space: nowrap;
}

.experiments-compact__sig--win {
    background: rgba(76, 175, 80, 0.18);
    color: #8de08e;
    border-color: rgba(76, 175, 80, 0.4);
}

.experiments-compact__sig--loss {
    background: rgba(244, 67, 54, 0.18);
    color: #ff8a80;
    border-color: rgba(244, 67, 54, 0.4);
}

.experiments-compact__sig--warn {
    background: rgba(255, 152, 0, 0.18);
    color: #ffc97a;
    border-color: rgba(255, 152, 0, 0.4);
}

.experiments-compact__sig--soft {
    background: rgba(120, 144, 156, 0.18);
    color: #b0bec5;
    border-color: rgba(120, 144, 156, 0.32);
}

.experiments-compact__sig--control {
    background: rgba(96, 125, 139, 0.22);
    color: #c2d1d9;
    border-color: rgba(96, 125, 139, 0.4);
}

/* ---------------------------------------------------------------- */
/* Experiments list view — domain-scoped summary cards              */
/* ---------------------------------------------------------------- */

.experiments-list-intro-block {
    flex: 1 1 320px;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.experiments-list-domain-pill {
    display: inline-flex;
    align-self: flex-start;
    align-items: center;
    padding: 3px 10px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    background: rgba(192, 159, 83, 0.16);
    color: #f5d27a;
    border: 1px solid rgba(192, 159, 83, 0.35);
}

.experiments-list-empty {
    background: rgba(22, 22, 26, 0.55);
    border: 1px dashed rgba(192, 159, 83, 0.25);
    border-radius: 12px;
    padding: 32px 28px;
    text-align: center;
    margin-top: 8px;
}

.experiments-list-empty__title {
    font-size: 16px;
    font-weight: 600;
    color: #f3f3f3;
    margin: 0 0 6px;
}

.experiments-list-empty__sub {
    font-size: 13px;
    color: #a4a4a8;
    margin: 0;
    line-height: 1.55;
}

.experiments-list-empty__sub code {
    background: rgba(192, 159, 83, 0.12);
    color: #f5d27a;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 12px;
}

.experiments-list-grid {
    list-style: none;
    padding: 0;
    margin: 8px 0 0;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 14px;
}

.experiments-list-card-wrap {
    list-style: none;
}

.experiments-list-card {
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: 18px 20px;
    background: rgba(22, 22, 26, 0.6);
    border: 1px solid rgba(192, 159, 83, 0.18);
    border-radius: 12px;
    text-decoration: none;
    color: inherit;
    transition: border-color 0.15s ease, transform 0.15s ease,
        background 0.15s ease;
    height: 100%;
}

.experiments-list-card:hover,
.experiments-list-card:focus-visible {
    border-color: rgba(192, 159, 83, 0.5);
    background: rgba(34, 34, 40, 0.85);
    transform: translateY(-1px);
    outline: none;
}

.experiments-list-card__header {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.experiments-list-card__title {
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    color: #f3f3f3;
    letter-spacing: -0.01em;
    word-break: break-word;
}

.experiments-list-card__chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.experiments-list-card__chip {
    display: inline-flex;
    align-items: center;
    padding: 3px 9px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.02em;
    background: rgba(96, 125, 139, 0.18);
    color: #c2d1d9;
    border: 1px solid rgba(96, 125, 139, 0.35);
}

.experiments-list-card__chip--channel {
    background: rgba(192, 159, 83, 0.16);
    color: #f5d27a;
    border-color: rgba(192, 159, 83, 0.4);
}

.experiments-list-card__chip--mixed {
    background: rgba(120, 144, 156, 0.18);
    color: #b0bec5;
    border-color: rgba(120, 144, 156, 0.35);
}

.experiments-list-card__chip--untargeted {
    background: rgba(158, 158, 158, 0.14);
    color: #c4c4c4;
    border-color: rgba(158, 158, 158, 0.3);
}

.experiments-list-card__chip--domain {
    background: rgba(34, 34, 40, 0.95);
    color: #ececec;
    border-color: rgba(255, 255, 255, 0.12);
}

.experiments-list-card__metrics {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
    gap: 10px 14px;
    margin: 0;
}

.experiments-list-card__metrics > div {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
}

.experiments-list-card__metrics dt {
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: rgba(192, 159, 83, 0.85);
    font-weight: 600;
}

.experiments-list-card__metrics dd {
    margin: 0;
    font-size: 15px;
    font-weight: 700;
    color: #f3f3f3;
    line-height: 1.2;
    font-variant-numeric: tabular-nums;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.experiments-list-card__leader {
    display: inline-flex;
    align-items: baseline;
    gap: 6px;
}

.experiments-list-card__leader-rate {
    font-size: 11px;
    color: #8de08e;
    font-weight: 600;
}

.experiments-list-card__cta {
    margin-top: auto;
    align-self: flex-start;
    font-size: 12px;
    font-weight: 600;
    color: rgba(192, 159, 83, 0.9);
    letter-spacing: 0.02em;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Experiments/Experiments.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;IACI,wDAAwD;IACxD,gGAAgG;AACpG;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,SAAS;IACT,wCAAwC;IACxC,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,sDAAsD;AAC1D;;AAEA;;;IAGI,gCAAgC;IAChC,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;IAC3C,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;IAC1C,2FAA2F;IAC3F,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,sDAAsD;IACtD;;;4BAGwB;IACxB,mDAAmD;AACvD;;AAEA;IACI,sCAAsC;IACtC,2FAA2F;IAC3F,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;IACd,8BAA8B;IAC9B,2CAA2C;IAC3C,mBAAmB;IACnB,eAAe;IACf;;;4BAGwB;AAC5B;;AAEA;IACI,cAAc;IACd,qCAAqC;IACrC,oCAAoC;AACxC;;AAEA;IACI,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,uEAAuE;IACvE,2BAA2B;IAC3B,eAAe;AACnB;;AAEA,gCAAgC;AAChC;IACI,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;IAC/B,0CAA0C;IAC1C,2FAA2F;IAC3F;;+CAE2C;IAC3C,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,4BAA4B;IAC5B,sFAAsF;IACtF,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,sCAAsC;IACtC;;;+CAG2C;AAC/C;;AAEA;IACI,UAAU;IACV,UAAU;IACV,gBAAgB;IAChB,sFAAsF;AAC1F;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,yCAAyC;IACzC,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,oBAAoB;IACpB,yCAAyC;IACzC,+FAA+F;IAC/F,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,+BAA+B;IAC/B,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,2CAA2C;IAC3C,+BAA+B;IAC/B,mDAAmD;IACnD,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,+BAA+B;IAC/B,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,gDAAgD;IAChD,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,2CAA2C;IAC3C,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,SAAS;IACT,cAAc;IACd,kDAAkD;IAClD,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,cAAc;IACd,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA,wDAAwD;AACxD;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,gCAAgC;IAChC,qCAAqC;IACrC,0CAA0C;IAC1C,oBAAoB;IACpB,eAAe;IACf,4EAA4E;AAChF;;AAEA;;IAEI,cAAc;IACd,sCAAsC;IACtC,oCAAoC;AACxC;;AAEA;IACI,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd;;;;KAIC;IACD,sCAAsC;AAC1C;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,iCAAiC;AACrC;;AAEA;IACI,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,+BAA+B;IAC/B,2CAA2C;IAC3C,oBAAoB;IACpB,kCAAkC;AACtC;;AAEA,2CAA2C;AAC3C;IACI,gCAAgC;AACpC;;AAEA;IACI,uCAAuC;IACvC,qCAAqC;AACzC;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA,qDAAqD;AACrD;IACI,aAAa;IACb,eAAe;IACf;;;;;;MAME;IACF,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI;;;;;MAKE;IACF,SAAS;AACb;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;IACd;;;;KAIC;IACD,0CAA0C;IAC1C,mBAAmB;IACnB,eAAe;IACf,mDAAmD;AACvD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,uCAAuC;AAC3C;;AAEA,qCAAqC;AACrC;IACI,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;IAC/B,mBAAmB;IACnB,0CAA0C;IAC1C;;;;KAIC;IACD;;+CAE2C;IAC3C,gCAAgC;IAChC,gGAAgG;AACpG;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,kDAAkD;AACtD;;AAEA;IACI,eAAe;IACf,yCAAyC;IACzC,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;IAChC,qCAAqC;IACrC,2CAA2C;IAC3C,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,cAAc;IACd,oBAAoB;IACpB,gCAAgC;IAChC,uBAAuB;IACvB,2CAA2C;IAC3C,kBAAkB;IAClB,eAAe;IACf,4EAA4E;AAChF;;AAEA;;IAEI,cAAc;IACd,sCAAsC;IACtC,mCAAmC;AACvC;;AAEA;;;;;IAKI,mBAAmB;AACvB;;AAEA,iDAAiD;AACjD;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,+BAA+B;AACnC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,aAAa;IACb,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,mCAAmC;IACnC,0CAA0C;IAC1C,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;IAChB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,+BAA+B;AACnC;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,sDAAsD;IACtD,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;IAChC,qCAAqC;IACrC,2CAA2C;IAC3C,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;IACd,+BAA+B;IAC/B,2CAA2C;IAC3C,kBAAkB;IAClB,0DAA0D;IAC1D,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,wDAAwD;IACxD,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,UAAU;IACV,2CAA2C;IAC3C,kBAAkB;IAClB,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,sCAAsC;IACtC,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,gCAAgC;IAChC,uBAAuB;IACvB,2CAA2C;IAC3C,kBAAkB;IAClB,eAAe;IACf,4EAA4E;AAChF;;AAEA;;IAEI,cAAc;IACd,qCAAqC;IACrC,mCAAmC;AACvC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,gCAAgC;IAChC,qCAAqC;IACrC,4CAA4C;IAC5C,kBAAkB;IAClB,eAAe;IACf,4EAA4E;AAChF;;AAEA;;IAEI,cAAc;IACd,qCAAqC;IACrC,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;IAChC,+BAA+B;IAC/B,2CAA2C;IAC3C,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC;;;;KAIC;IACD,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;IACd;;;;KAIC;IACD,0CAA0C;IAC1C,kBAAkB;IAClB,eAAe;IACf,6BAA6B;AACjC;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qDAAqD;IACrD,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,qFAAqF;IACrF,qCAAqC;AACzC;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,+BAA+B;IAC/B,cAAc;IACd,sDAAsD;IACtD,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI;QACI,8BAA8B;IAClC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;IACvB;AACJ;;AAEA,qEAAqE;AACrE,qEAAqE;AACrE,qEAAqE;;AAErE;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB;;;;KAIC;IACD,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,+CAA+C;IAC/C,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,qCAAqC;IACrC,cAAc;IACd,2CAA2C;AAC/C;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,8CAA8C;QAC9C,iBAAiB;IACrB;AACJ;;AAEA,qEAAqE;AACrE,qEAAqE;AACrE,qEAAqE;;AAErE;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kCAAkC;IAClC,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,cAAc;IACd,0CAA0C;IAC1C,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,mCAAmC;AACvC;;AAEA;;IAEI,sCAAsC;IACtC,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,0CAA0C;IAC1C,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,mDAAmD;AACvD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA,qEAAqE;AACrE,qEAAqE;AACrE,qEAAqE;;AAErE;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,oCAAoC;IACpC,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,qCAAqC;IACrC,cAAc;IACd,2CAA2C;AAC/C;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,qCAAqC;IACrC,cAAc;IACd,2CAA2C;AAC/C;;AAEA;IACI,qCAAqC;IACrC,cAAc;IACd,0CAA0C;AAC9C;;AAEA,qEAAqE;AACrE,qEAAqE;AACrE,qEAAqE;;AAErE;IACI,gBAAgB;IAChB,kCAAkC;IAClC,0CAA0C;IAC1C,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;IAC/B,iDAAiD;IACjD,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kDAAkD;IAClD,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;IACjB,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;IAChB,oCAAoC;IACpC,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,qCAAqC;IACrC,cAAc;IACd,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,qCAAqC;IACrC,cAAc;IACd,uCAAuC;AAC3C;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,qCAAqC;AACzC;;AAEA,qEAAqE;AACrE,qEAAqE;AACrE,qEAAqE;;AAErE;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,oCAAoC;IACpC,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,kCAAkC;IAClC,2CAA2C;IAC3C,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,iCAAiC;IACjC,0CAA0C;IAC1C,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd;6BACyB;IACzB,YAAY;AAChB;;AAEA;;IAEI,qCAAqC;IACrC,kCAAkC;IAClC,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,oCAAoC;IACpC,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,cAAc;IACd,uCAAuC;AAC3C;;AAEA;IACI,qCAAqC;IACrC,cAAc;IACd,sCAAsC;AAC1C;;AAEA;IACI,kCAAkC;IAClC,cAAc;IACd,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,cAAc;IACd,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kCAAkC;IAClC,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,8BAA8B;IAC9B,sBAAsB;AAC1B","sourcesContent":["/* ——— Experiments page (list + detail) ——— */\n.experiments-page {\n    padding: 0 clamp(16px, 3vw, 28px) clamp(24px, 4vw, 40px);\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Arial, sans-serif;\n}\n\n.experiments-page__title {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin: 0;\n    font-size: clamp(1.1rem, 2.5vw, 1.35rem);\n    font-weight: 650;\n    letter-spacing: -0.02em;\n    color: #f0f0f0;\n}\n\n.experiments-page__title-icon {\n    flex-shrink: 0;\n    opacity: 0.92;\n    filter: drop-shadow(0 0 10px rgba(192, 159, 83, 0.25));\n}\n\n.experiments-loading,\n.experiments-error,\n.experiments-empty {\n    color: rgba(180, 180, 180, 0.95);\n    margin-top: 18px;\n    font-size: 0.9375rem;\n}\n\n.experiments-empty {\n    margin-top: 24px;\n    text-align: center;\n    font-weight: 500;\n    line-height: 1.55;\n    padding: 28px 20px;\n    border: 1px solid rgba(255, 255, 255, 0.09);\n    border-radius: 14px;\n    background: rgba(0, 0, 0, 0.2);\n    max-width: 520px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.experiments-error {\n    color: #e8a0a0;\n}\n\n.experiments-list {\n    margin-top: 20px;\n}\n\n.experiments-list-intro {\n    color: rgba(165, 165, 165, 0.95);\n    margin-bottom: 16px;\n    font-size: 0.9375rem;\n    line-height: 1.5;\n    max-width: 42em;\n}\n\n.experiments-id-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    max-width: 480px;\n}\n\n.experiments-id-link {\n    display: block;\n    padding: 14px 18px;\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    background: linear-gradient(165deg, rgba(52, 52, 56, 0.45) 0%, rgba(24, 24, 28, 0.65) 100%);\n    color: #e8dcc8;\n    text-decoration: none;\n    font-weight: 600;\n    font-size: 0.9rem;\n    font-family: ui-monospace, \"SF Mono\", Menlo, monospace;\n    transition:\n        border-color 0.2s ease,\n        background 0.2s ease,\n        transform 0.15s ease;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);\n}\n\n.experiments-id-link:hover {\n    border-color: rgba(192, 159, 83, 0.45);\n    background: linear-gradient(165deg, rgba(72, 68, 58, 0.55) 0%, rgba(32, 30, 26, 0.75) 100%);\n    color: #faf6ee;\n}\n\n.experiments-id-link:active {\n    transform: translateY(1px);\n}\n\n.experiments-back {\n    margin-left: 10px;\n    padding: 8px 14px;\n    font-size: 0.8125rem;\n    font-weight: 600;\n    font-family: inherit;\n    color: #c8c8c8;\n    background: rgba(0, 0, 0, 0.2);\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 10px;\n    cursor: pointer;\n    transition:\n        color 0.2s ease,\n        border-color 0.2s ease,\n        background 0.2s ease;\n}\n\n.experiments-back:hover {\n    color: #f0f0f0;\n    border-color: rgba(192, 159, 83, 0.4);\n    background: rgba(192, 159, 83, 0.08);\n}\n\n.experiments-back:focus-visible {\n    outline: 2px solid rgba(192, 159, 83, 0.55);\n    outline-offset: 2px;\n}\n\n/* ——— Variant grid ——— */\n.experiments-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(min(100%, 380px), 1fr));\n    gap: clamp(18px, 3vw, 26px);\n    margin-top: 8px;\n}\n\n/* ——— Single variant card ——— */\n.experiment-card {\n    position: relative;\n    border-radius: 16px;\n    padding: clamp(18px, 3vw, 24px);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    background: linear-gradient(168deg, rgba(52, 52, 56, 0.55) 0%, rgba(22, 22, 26, 0.92) 100%);\n    box-shadow:\n        0 20px 48px rgba(0, 0, 0, 0.35),\n        inset 0 1px 0 rgba(255, 255, 255, 0.05);\n    color: rgba(200, 200, 200, 0.98);\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    overflow: hidden;\n}\n\n.experiment-card::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 38%;\n    max-width: 160px;\n    height: 3px;\n    border-radius: 0 0 10px 10px;\n    background: linear-gradient(90deg, transparent, rgba(192, 159, 83, 0.75), transparent);\n    pointer-events: none;\n    opacity: 0.85;\n}\n\n.experiment-card--winning {\n    border-color: rgba(192, 159, 83, 0.42);\n    box-shadow:\n        0 0 0 1px rgba(192, 159, 83, 0.12),\n        0 22px 56px rgba(0, 0, 0, 0.42),\n        inset 0 1px 0 rgba(255, 255, 255, 0.06);\n}\n\n.experiment-card--winning::before {\n    opacity: 1;\n    width: 48%;\n    max-width: 200px;\n    background: linear-gradient(90deg, transparent, rgba(192, 159, 83, 0.95), transparent);\n}\n\n.experiment-card__header {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    padding-bottom: 4px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.07);\n}\n\n.experiment-card__title-row {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 10px 14px;\n}\n\n.experiment-card__variant {\n    margin: 0;\n    font-size: clamp(1.05rem, 2.4vw, 1.35rem);\n    font-weight: 650;\n    letter-spacing: -0.02em;\n    color: #f4f4f4;\n    line-height: 1.25;\n    word-break: break-word;\n}\n\n.experiment-card__winning-badge {\n    font-size: 0.65rem;\n    font-weight: 700;\n    letter-spacing: 0.12em;\n    text-transform: uppercase;\n    color: #faf6ee;\n    padding: 6px 12px;\n    border-radius: 999px;\n    border: 1px solid rgba(192, 159, 83, 0.5);\n    background: linear-gradient(180deg, rgba(192, 159, 83, 0.32) 0%, rgba(140, 115, 60, 0.22) 100%);\n    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);\n}\n\n.experiment-card__meta {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n}\n\n.experiment-card__chip {\n    display: inline-flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n    padding: 10px 14px;\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.09);\n    background: rgba(0, 0, 0, 0.28);\n    font-size: 0.8125rem;\n    line-height: 1.35;\n    color: #dcdcdc;\n    max-width: 100%;\n    word-break: break-word;\n}\n\n.experiment-card__chip-key {\n    font-size: 0.625rem;\n    font-weight: 700;\n    letter-spacing: 0.14em;\n    text-transform: uppercase;\n    color: rgba(192, 159, 83, 0.92);\n}\n\n/* ——— Chart row ——— */\n.experiment-card__charts {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 12px;\n}\n\n.experiment-card__chart-panel {\n    padding: 14px 12px 16px;\n    border-radius: 14px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: rgba(0, 0, 0, 0.22);\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    min-width: 0;\n}\n\n.experiment-card__chart-inner {\n    width: 124px;\n    height: 124px;\n    position: relative;\n    margin: 0 auto 4px;\n}\n\n.experiment-card__chart-inner canvas {\n    max-width: 100% !important;\n    max-height: 100% !important;\n}\n\n.experiment-card__chart-caption {\n    font-size: 0.6875rem;\n    font-weight: 700;\n    letter-spacing: 0.11em;\n    text-transform: uppercase;\n    color: rgba(192, 159, 83, 0.95);\n    margin-top: 4px;\n}\n\n.experiment-card__chart-hint {\n    font-size: 0.6875rem;\n    color: rgba(150, 150, 150, 0.9);\n    margin-top: 4px;\n    line-height: 1.35;\n    max-width: 11rem;\n}\n\n/* ——— Metrics ——— */\n.experiment-card__metrics-grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 16px 20px;\n}\n\n.experiment-card__section {\n    min-width: 0;\n    padding: 14px 14px 12px;\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    background: rgba(0, 0, 0, 0.15);\n}\n\n.experiment-card__section-title {\n    margin: 0 0 12px;\n    font-size: 0.625rem;\n    font-weight: 700;\n    letter-spacing: 0.14em;\n    text-transform: uppercase;\n    color: rgba(192, 159, 83, 0.92);\n}\n\n.experiment-card__metrics {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.experiment-card__metrics li {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n    gap: 12px;\n    padding: 8px 0;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n    font-size: 0.8125rem;\n}\n\n.experiment-card__metrics li:last-child {\n    border-bottom: none;\n    padding-bottom: 0;\n}\n\n.experiment-card__metrics .metric-label {\n    color: rgba(165, 165, 165, 0.98);\n    flex: 1;\n    min-width: 0;\n}\n\n.experiment-card__metrics .metric-value {\n    font-weight: 650;\n    font-variant-numeric: tabular-nums;\n    color: #ececec;\n    text-align: right;\n    flex-shrink: 0;\n}\n\n.experiments-filters {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    justify-content: flex-end;\n}\n\n/* ——— Channel filter bar (above the variant grid) ——— */\n.experiments-filter-bar {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 12px 16px;\n    margin: 0 0 18px;\n    padding: 12px 16px;\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: rgba(0, 0, 0, 0.22);\n}\n\n.experiments-filter-bar__label {\n    font-size: 0.7rem;\n    font-weight: 700;\n    letter-spacing: 0.14em;\n    text-transform: uppercase;\n    color: rgba(192, 159, 83, 0.92);\n    flex-shrink: 0;\n}\n\n.experiments-filter-bar__chips {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px 8px;\n    flex: 1 1 auto;\n    min-width: 0;\n}\n\n.experiments-filter-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 12px;\n    font-size: 0.8rem;\n    font-weight: 600;\n    font-family: inherit;\n    color: rgba(220, 220, 230, 0.92);\n    background: rgba(255, 255, 255, 0.03);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 999px;\n    cursor: pointer;\n    transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;\n}\n\n.experiments-filter-chip:hover,\n.experiments-filter-chip:focus-visible {\n    color: #faf6ee;\n    border-color: rgba(192, 159, 83, 0.45);\n    background: rgba(192, 159, 83, 0.08);\n}\n\n.experiments-filter-chip:focus-visible {\n    outline: 2px solid rgba(192, 159, 83, 0.55);\n    outline-offset: 2px;\n}\n\n.experiments-filter-chip.is-active {\n    color: #20180c;\n    background: linear-gradient(\n        165deg,\n        rgba(216, 181, 106, 0.96) 0%,\n        rgba(184, 141, 60, 0.96) 100%\n    );\n    border-color: rgba(192, 159, 83, 0.55);\n}\n\n.experiments-filter-chip.is-active .experiments-filter-chip__count {\n    color: rgba(20, 18, 12, 0.78);\n    background: rgba(0, 0, 0, 0.18);\n    border-color: rgba(0, 0, 0, 0.18);\n}\n\n.experiments-filter-chip--untargeted:not(.is-active) {\n    color: rgba(180, 180, 190, 0.86);\n    border-style: dashed;\n}\n\n.experiments-filter-chip__count {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 1.5em;\n    padding: 1px 7px;\n    font-size: 0.7rem;\n    font-weight: 700;\n    color: rgba(220, 220, 230, 0.92);\n    background: rgba(0, 0, 0, 0.32);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 999px;\n    font-variant-numeric: tabular-nums;\n}\n\n/* ——— Audience chip on variant cards ——— */\n.experiment-card__chip--channel .experiment-card__chip-key {\n    color: rgba(190, 220, 245, 0.92);\n}\n\n.experiment-card__chip--channel {\n    border-color: rgba(130, 175, 220, 0.32);\n    background: rgba(130, 175, 220, 0.08);\n}\n\n@media screen and (max-width: 640px) {\n    .experiment-card__charts {\n        grid-template-columns: 1fr;\n    }\n\n    .experiment-card__metrics-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n@media screen and (max-width: 900px) {\n    .experiments-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n/* ——— List actions row (intro + create button) ——— */\n.experiments-list-actions {\n    display: flex;\n    flex-wrap: wrap;\n    /*\n     * Center-align so the intro copy sits at the same vertical\n     * midpoint as the (taller, padded) \"Create experiment\" button.\n     * Using flex-start let the paragraph baseline ride up to the top\n     * of the row while the button's label centered inside its\n     * padding, which read as the intro being \"too high\".\n     */\n    align-items: center;\n    justify-content: space-between;\n    gap: 14px 18px;\n    margin-bottom: 18px;\n}\n\n.experiments-list-actions .experiments-list-intro {\n    /*\n     * <p> defaults to 1em top + bottom margin which would push the\n     * intro down inside its intro-block flex column and add a stray\n     * gap above the optional domain pill. Reset both — the intro-\n     * block already provides spacing via its own `gap`.\n     */\n    margin: 0;\n}\n\n.experiments-create-toggle {\n    flex-shrink: 0;\n    padding: 10px 18px;\n    font-size: 0.84rem;\n    font-weight: 650;\n    font-family: inherit;\n    color: #20180c;\n    background: linear-gradient(\n        165deg,\n        rgba(216, 181, 106, 0.96) 0%,\n        rgba(184, 141, 60, 0.96) 100%\n    );\n    border: 1px solid rgba(192, 159, 83, 0.55);\n    border-radius: 10px;\n    cursor: pointer;\n    transition: filter 0.15s ease, transform 0.15s ease;\n}\n\n.experiments-create-toggle:hover {\n    filter: brightness(1.07);\n}\n\n.experiments-create-toggle:focus-visible {\n    outline: 2px solid rgba(192, 159, 83, 0.6);\n    outline-offset: 2px;\n}\n\n.experiments-create-toggle:active {\n    transform: translateY(1px);\n}\n\n.experiments-create-toggle[aria-expanded=\"true\"] {\n    color: #e8dcc8;\n    background: rgba(0, 0, 0, 0.25);\n    border-color: rgba(255, 255, 255, 0.14);\n}\n\n/* ——— Experiment builder panel ——— */\n.experiment-builder {\n    position: relative;\n    margin: 0 0 28px;\n    padding: clamp(20px, 3vw, 28px);\n    border-radius: 16px;\n    border: 1px solid rgba(192, 159, 83, 0.22);\n    background: linear-gradient(\n        168deg,\n        rgba(54, 48, 32, 0.42) 0%,\n        rgba(22, 22, 26, 0.92) 100%\n    );\n    box-shadow:\n        0 18px 44px rgba(0, 0, 0, 0.32),\n        inset 0 1px 0 rgba(255, 255, 255, 0.04);\n    color: rgba(220, 220, 220, 0.96);\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Arial, sans-serif;\n}\n\n.experiment-builder__head {\n    position: relative;\n    margin: 0 0 22px;\n    padding-bottom: 16px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.07);\n}\n\n.experiment-builder__title {\n    margin: 0 0 6px;\n    font-size: clamp(1.05rem, 2.2vw, 1.25rem);\n    font-weight: 650;\n    letter-spacing: -0.01em;\n    color: #faf6ee;\n}\n\n.experiment-builder__intro {\n    margin: 0;\n    font-size: 0.86rem;\n    line-height: 1.55;\n    color: rgba(180, 180, 185, 0.92);\n    max-width: 56rem;\n}\n\n.experiment-builder__intro code {\n    padding: 1px 6px;\n    font-size: 0.78rem;\n    color: rgba(232, 220, 200, 0.95);\n    background: rgba(255, 255, 255, 0.05);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 4px;\n}\n\n.experiment-builder__close {\n    position: absolute;\n    top: -4px;\n    right: -4px;\n    width: 32px;\n    height: 32px;\n    padding: 0;\n    font-size: 1.2rem;\n    line-height: 1;\n    font-family: inherit;\n    color: rgba(200, 200, 210, 0.86);\n    background: transparent;\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 8px;\n    cursor: pointer;\n    transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;\n}\n\n.experiment-builder__close:hover,\n.experiment-builder__close:focus-visible {\n    color: #f0f0f0;\n    border-color: rgba(192, 159, 83, 0.55);\n    background: rgba(192, 159, 83, 0.1);\n}\n\n.experiment-builder__field,\n.experiment-builder__channel,\n.experiment-builder__variants,\n.experiment-builder__split,\n.experiment-builder__output {\n    margin-bottom: 20px;\n}\n\n/* ——— Audience targeting (channel) section ——— */\n.experiment-builder__channel-head {\n    margin-bottom: 12px;\n}\n\n.experiment-builder__channel-head em {\n    font-style: italic;\n    color: rgba(220, 220, 230, 0.95);\n}\n\n.experiment-builder__channel-controls {\n    display: grid;\n    gap: 14px;\n}\n\n.experiment-builder__channel-detail {\n    padding: 14px 16px;\n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.07);\n    background: rgba(0, 0, 0, 0.22);\n}\n\n.experiment-builder__channel-detail .experiment-builder__hint:first-child {\n    margin-top: 0;\n}\n\n.experiment-builder__alias-list {\n    list-style: none;\n    margin: 8px 0 0;\n    padding: 0;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px 8px;\n}\n\n.experiment-builder__alias-list li {\n    display: inline-flex;\n    align-items: center;\n    padding: 4px 10px;\n    background: rgba(192, 159, 83, 0.1);\n    border: 1px solid rgba(192, 159, 83, 0.28);\n    border-radius: 999px;\n}\n\n.experiment-builder__alias-list code {\n    font-size: 0.74rem;\n    color: rgba(232, 220, 200, 0.95);\n    background: none;\n    border: none;\n    padding: 0;\n}\n\n.experiment-builder__channel-custom {\n    display: grid;\n    grid-template-columns: minmax(180px, 1fr) minmax(180px, 1fr);\n    gap: 12px;\n    padding: 14px 16px;\n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.07);\n    background: rgba(0, 0, 0, 0.22);\n}\n\n.experiment-builder__channel-custom .experiment-builder__variant-field:nth-child(3),\n.experiment-builder__channel-custom > .experiment-builder__hint {\n    grid-column: 1 / -1;\n}\n\n.experiment-builder__input--textarea {\n    font-family: ui-monospace, \"SF Mono\", Menlo, monospace;\n    font-size: 0.8rem;\n    line-height: 1.5;\n    resize: vertical;\n    min-height: 48px;\n}\n\n@media screen and (max-width: 720px) {\n    .experiment-builder__channel-custom {\n        grid-template-columns: 1fr;\n    }\n}\n\n.experiment-builder__label {\n    display: block;\n    margin-bottom: 6px;\n    font-size: 0.78rem;\n    font-weight: 700;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    color: rgba(192, 159, 83, 0.92);\n}\n\n.experiment-builder__hint {\n    margin: 6px 0 0;\n    font-size: 0.78rem;\n    line-height: 1.5;\n    color: rgba(160, 160, 170, 0.92);\n}\n\n.experiment-builder__hint code {\n    padding: 1px 5px;\n    font-size: 0.72rem;\n    color: rgba(220, 220, 230, 0.92);\n    background: rgba(255, 255, 255, 0.04);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 4px;\n}\n\n.experiment-builder__input {\n    width: 100%;\n    padding: 9px 12px;\n    font-size: 0.86rem;\n    font-family: inherit;\n    color: #f0f0f0;\n    background: rgba(0, 0, 0, 0.32);\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 8px;\n    transition: border-color 0.15s ease, background 0.15s ease;\n    box-sizing: border-box;\n}\n\n.experiment-builder__input:focus {\n    outline: none;\n    border-color: rgba(192, 159, 83, 0.6);\n    background: rgba(0, 0, 0, 0.42);\n}\n\n.experiment-builder__input::placeholder {\n    color: rgba(160, 160, 170, 0.6);\n}\n\n.experiment-builder__subtitle {\n    margin: 0 0 8px;\n    font-size: 0.95rem;\n    font-weight: 650;\n    color: #f0f0f0;\n}\n\n.experiment-builder__subtitle--small {\n    font-size: 0.78rem;\n    font-weight: 700;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    color: rgba(192, 159, 83, 0.92);\n}\n\n.experiment-builder__variants-head {\n    margin-bottom: 12px;\n}\n\n.experiment-builder__variants-head em {\n    font-style: italic;\n    color: rgba(220, 220, 230, 0.95);\n}\n\n.experiment-builder__variant-list {\n    list-style: none;\n    margin: 0 0 12px;\n    padding: 0;\n    display: grid;\n    gap: 12px;\n}\n\n.experiment-builder__variant {\n    padding: 14px 16px;\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: rgba(0, 0, 0, 0.22);\n}\n\n.experiment-builder__variant-row {\n    display: grid;\n    grid-template-columns: minmax(140px, 1fr) 110px 1fr auto;\n    gap: 12px;\n    align-items: end;\n}\n\n.experiment-builder__variant-field {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n}\n\n.experiment-builder__variant-field--narrow {\n    max-width: 110px;\n}\n\n.experiment-builder__variant-field--color .experiment-builder__color-row {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.experiment-builder__variant-field--color .experiment-builder__input {\n    flex: 1;\n    min-width: 0;\n}\n\n.experiment-builder__color-picker {\n    flex-shrink: 0;\n    width: 38px;\n    height: 38px;\n    padding: 0;\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 8px;\n    background: rgba(0, 0, 0, 0.32);\n    cursor: pointer;\n}\n\n.experiment-builder__color-picker::-webkit-color-swatch-wrapper {\n    padding: 4px;\n}\n\n.experiment-builder__color-picker::-webkit-color-swatch {\n    border-radius: 5px;\n    border: none;\n}\n\n.experiment-builder__field-key {\n    margin-bottom: 5px;\n    font-size: 0.7rem;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: rgba(170, 170, 180, 0.85);\n}\n\n.experiment-builder__checkbox {\n    grid-column: 1 / -2;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    margin-top: 4px;\n    font-size: 0.82rem;\n    color: rgba(200, 200, 210, 0.92);\n    cursor: pointer;\n}\n\n.experiment-builder__checkbox input[type=\"checkbox\"] {\n    accent-color: rgba(192, 159, 83, 0.85);\n    width: 16px;\n    height: 16px;\n}\n\n.experiment-builder__remove {\n    align-self: end;\n    padding: 8px 12px;\n    font-size: 0.78rem;\n    font-family: inherit;\n    color: rgba(220, 180, 180, 0.92);\n    background: transparent;\n    border: 1px solid rgba(220, 100, 100, 0.32);\n    border-radius: 8px;\n    cursor: pointer;\n    transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;\n}\n\n.experiment-builder__remove:hover:not(:disabled),\n.experiment-builder__remove:focus-visible:not(:disabled) {\n    color: #fbe6e6;\n    border-color: rgba(232, 95, 95, 0.65);\n    background: rgba(232, 95, 95, 0.12);\n}\n\n.experiment-builder__remove:disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n}\n\n.experiment-builder__variant-settings {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n    gap: 12px;\n    margin-top: 14px;\n    padding: 12px 14px;\n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.05);\n    background: rgba(0, 0, 0, 0.18);\n}\n\n.experiment-builder__add {\n    padding: 10px 16px;\n    font-size: 0.84rem;\n    font-weight: 600;\n    font-family: inherit;\n    color: rgba(220, 220, 230, 0.92);\n    background: rgba(255, 255, 255, 0.04);\n    border: 1px dashed rgba(255, 255, 255, 0.18);\n    border-radius: 9px;\n    cursor: pointer;\n    transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;\n}\n\n.experiment-builder__add:hover,\n.experiment-builder__add:focus-visible {\n    color: #faf6ee;\n    border-color: rgba(192, 159, 83, 0.5);\n    background: rgba(192, 159, 83, 0.08);\n}\n\n.experiment-builder__split-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px 12px;\n}\n\n.experiment-builder__split-list li {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 12px;\n    font-size: 0.78rem;\n    color: rgba(220, 220, 230, 0.92);\n    background: rgba(0, 0, 0, 0.28);\n    border: 1px solid rgba(255, 255, 255, 0.07);\n    border-radius: 999px;\n}\n\n.experiment-builder__split-list code {\n    font-size: 0.78rem;\n    color: rgba(232, 220, 200, 0.95);\n}\n\n.experiment-builder__split-list span {\n    font-variant-numeric: tabular-nums;\n    color: rgba(192, 159, 83, 0.92);\n    font-weight: 650;\n}\n\n.experiment-builder__errors {\n    margin-bottom: 16px;\n    padding: 12px 16px;\n    border-radius: 10px;\n    border: 1px solid rgba(232, 95, 95, 0.4);\n    background: linear-gradient(\n        155deg,\n        rgba(232, 95, 95, 0.12) 0%,\n        rgba(0, 0, 0, 0.22) 65%\n    );\n    color: rgba(255, 220, 220, 0.95);\n    font-size: 0.82rem;\n    line-height: 1.5;\n}\n\n.experiment-builder__errors strong {\n    display: block;\n    margin-bottom: 6px;\n    color: rgba(255, 200, 200, 0.96);\n}\n\n.experiment-builder__errors ul {\n    margin: 0;\n    padding-left: 18px;\n}\n\n.experiment-builder__output-head {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px 14px;\n    margin-bottom: 8px;\n}\n\n.experiment-builder__copy {\n    padding: 8px 16px;\n    font-size: 0.82rem;\n    font-weight: 650;\n    font-family: inherit;\n    color: #20180c;\n    background: linear-gradient(\n        165deg,\n        rgba(216, 181, 106, 0.96) 0%,\n        rgba(184, 141, 60, 0.96) 100%\n    );\n    border: 1px solid rgba(192, 159, 83, 0.55);\n    border-radius: 9px;\n    cursor: pointer;\n    transition: filter 0.15s ease;\n}\n\n.experiment-builder__copy:hover:not(:disabled),\n.experiment-builder__copy:focus-visible:not(:disabled) {\n    filter: brightness(1.07);\n}\n\n.experiment-builder__copy:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n}\n\n.experiment-builder__copy--ok {\n    color: #1a3a1a;\n    background: linear-gradient(165deg, #a8d39c, #6fae62);\n    border-color: rgba(150, 200, 130, 0.6);\n}\n\n.experiment-builder__copy--err {\n    color: #fbe6e6;\n    background: linear-gradient(165deg, rgba(232, 95, 95, 0.85), rgba(180, 60, 60, 0.85));\n    border-color: rgba(232, 95, 95, 0.55);\n}\n\n.experiment-builder__snippet {\n    margin: 0;\n    padding: 16px 18px;\n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: rgba(0, 0, 0, 0.42);\n    color: #e8dcc8;\n    font-family: ui-monospace, \"SF Mono\", Menlo, monospace;\n    font-size: 0.78rem;\n    line-height: 1.6;\n    white-space: pre;\n    overflow-x: auto;\n    max-height: 360px;\n    overflow-y: auto;\n}\n\n.experiment-builder__snippet code {\n    background: none;\n    border: none;\n    padding: 0;\n    color: inherit;\n    font-size: inherit;\n}\n\n@media screen and (max-width: 720px) {\n    .experiment-builder__variant-row {\n        grid-template-columns: 1fr 1fr;\n    }\n\n    .experiment-builder__variant-row .experiment-builder__variant-field--narrow {\n        max-width: none;\n    }\n\n    .experiment-builder__checkbox {\n        grid-column: 1 / -1;\n    }\n\n    .experiment-builder__remove {\n        grid-column: 1 / -1;\n        justify-self: start;\n    }\n}\n\n/* ---------------------------------------------------------------- */\n/* Experiment summary strip                                         */\n/* ---------------------------------------------------------------- */\n\n.experiment-summary {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 18px;\n    padding: 18px 22px;\n    margin: 0 0 18px;\n    background: linear-gradient(\n        180deg,\n        rgba(192, 159, 83, 0.08) 0%,\n        rgba(22, 22, 26, 0.3) 100%\n    );\n    border: 1px solid rgba(192, 159, 83, 0.22);\n    border-radius: 12px;\n}\n\n.experiment-summary__cell {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 0;\n}\n\n.experiment-summary__label {\n    font-size: 11px;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    color: rgba(192, 159, 83, 0.85);\n    font-weight: 600;\n}\n\n.experiment-summary__value {\n    font-size: 22px;\n    font-weight: 700;\n    color: #f3f3f3;\n    line-height: 1.15;\n    letter-spacing: -0.01em;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.experiment-summary__value--leader {\n    color: #f5d27a;\n}\n\n.experiment-summary__sub {\n    font-size: 12px;\n    color: #a4a4a8;\n    line-height: 1.35;\n}\n\n.experiment-summary__cell--leader {\n    border-left: 1px solid rgba(192, 159, 83, 0.18);\n    padding-left: 18px;\n}\n\n.experiment-summary__confidence {\n    margin-top: 6px;\n    align-self: flex-start;\n    display: inline-flex;\n    align-items: center;\n    padding: 3px 8px;\n    border-radius: 999px;\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n}\n\n.experiment-summary__confidence--high {\n    background: rgba(76, 175, 80, 0.18);\n    color: #8de08e;\n    border: 1px solid rgba(76, 175, 80, 0.4);\n}\n\n.experiment-summary__confidence--mid {\n    background: rgba(255, 152, 0, 0.18);\n    color: #ffc97a;\n    border: 1px solid rgba(255, 152, 0, 0.4);\n}\n\n.experiment-summary__confidence--low {\n    background: rgba(158, 158, 158, 0.18);\n    color: #c4c4c4;\n    border: 1px solid rgba(158, 158, 158, 0.35);\n}\n\n@media screen and (max-width: 720px) {\n    .experiment-summary {\n        padding: 14px 16px;\n    }\n\n    .experiment-summary__value {\n        font-size: 19px;\n    }\n\n    .experiment-summary__cell--leader {\n        border-left: none;\n        padding-left: 0;\n        border-top: 1px solid rgba(192, 159, 83, 0.18);\n        padding-top: 12px;\n    }\n}\n\n/* ---------------------------------------------------------------- */\n/* Sort + view toolbar                                              */\n/* ---------------------------------------------------------------- */\n\n.experiments-toolbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    flex-wrap: wrap;\n    margin: 0 0 14px;\n    padding: 10px 14px;\n    background: rgba(22, 22, 26, 0.55);\n    border: 1px solid rgba(192, 159, 83, 0.14);\n    border-radius: 10px;\n}\n\n.experiments-toolbar__field {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.experiments-toolbar__label {\n    font-size: 11px;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    color: rgba(192, 159, 83, 0.85);\n    font-weight: 600;\n}\n\n.experiments-toolbar__select {\n    background: rgba(34, 34, 40, 0.95);\n    color: #ececec;\n    border: 1px solid rgba(192, 159, 83, 0.25);\n    border-radius: 6px;\n    padding: 6px 10px;\n    font-size: 13px;\n    cursor: pointer;\n    transition: border-color 0.15s ease;\n}\n\n.experiments-toolbar__select:hover,\n.experiments-toolbar__select:focus {\n    border-color: rgba(192, 159, 83, 0.55);\n    outline: none;\n}\n\n.experiments-toolbar__view {\n    display: inline-flex;\n    border: 1px solid rgba(192, 159, 83, 0.25);\n    border-radius: 6px;\n    overflow: hidden;\n}\n\n.experiments-toolbar__view-btn {\n    appearance: none;\n    background: rgba(34, 34, 40, 0.6);\n    color: #c4c4c4;\n    border: none;\n    padding: 6px 14px;\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    cursor: pointer;\n    transition: background 0.15s ease, color 0.15s ease;\n}\n\n.experiments-toolbar__view-btn:not(:last-child) {\n    border-right: 1px solid rgba(192, 159, 83, 0.25);\n}\n\n.experiments-toolbar__view-btn.is-active {\n    background: rgba(192, 159, 83, 0.22);\n    color: #f5d27a;\n}\n\n.experiments-toolbar__view-btn:not(.is-active):hover {\n    background: rgba(192, 159, 83, 0.1);\n    color: #ececec;\n}\n\n/* ---------------------------------------------------------------- */\n/* Lift chip + confidence badge on variant cards                    */\n/* ---------------------------------------------------------------- */\n\n.experiment-card__control-badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 3px 9px;\n    border-radius: 999px;\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    background: rgba(96, 125, 139, 0.22);\n    color: #c2d1d9;\n    border: 1px solid rgba(96, 125, 139, 0.45);\n}\n\n.experiment-card__lift-row {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-top: 6px;\n}\n\n.experiment-card__lift {\n    display: inline-flex;\n    align-items: center;\n    padding: 4px 10px;\n    border-radius: 999px;\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.01em;\n}\n\n.experiment-card__lift--up {\n    background: rgba(76, 175, 80, 0.18);\n    color: #8de08e;\n    border: 1px solid rgba(76, 175, 80, 0.4);\n}\n\n.experiment-card__lift--down {\n    background: rgba(244, 67, 54, 0.18);\n    color: #ff8a80;\n    border: 1px solid rgba(244, 67, 54, 0.4);\n}\n\n.experiment-card__lift--flat {\n    background: rgba(158, 158, 158, 0.18);\n    color: #c4c4c4;\n    border: 1px solid rgba(158, 158, 158, 0.35);\n}\n\n.experiment-card__confidence {\n    display: inline-flex;\n    align-items: center;\n    padding: 3px 9px;\n    border-radius: 999px;\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n}\n\n.experiment-card__confidence--win {\n    background: rgba(76, 175, 80, 0.14);\n    color: #8de08e;\n    border: 1px solid rgba(76, 175, 80, 0.3);\n}\n\n.experiment-card__confidence--loss {\n    background: rgba(244, 67, 54, 0.14);\n    color: #ff8a80;\n    border: 1px solid rgba(244, 67, 54, 0.3);\n}\n\n.experiment-card__confidence--warn {\n    background: rgba(255, 152, 0, 0.14);\n    color: #ffc97a;\n    border: 1px solid rgba(255, 152, 0, 0.3);\n}\n\n.experiment-card__confidence--soft {\n    background: rgba(120, 144, 156, 0.18);\n    color: #b0bec5;\n    border: 1px solid rgba(120, 144, 156, 0.32);\n}\n\n.experiment-card__confidence--neutral {\n    background: rgba(158, 158, 158, 0.14);\n    color: #c4c4c4;\n    border: 1px solid rgba(158, 158, 158, 0.3);\n}\n\n/* ---------------------------------------------------------------- */\n/* Compact table view                                               */\n/* ---------------------------------------------------------------- */\n\n.experiments-compact {\n    overflow-x: auto;\n    background: rgba(22, 22, 26, 0.55);\n    border: 1px solid rgba(192, 159, 83, 0.14);\n    border-radius: 10px;\n    padding: 4px;\n}\n\n.experiments-compact__table {\n    width: 100%;\n    border-collapse: collapse;\n    color: #ececec;\n    font-size: 13px;\n    min-width: 760px;\n}\n\n.experiments-compact__table thead th {\n    text-align: left;\n    padding: 10px 12px;\n    font-weight: 600;\n    font-size: 11px;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: rgba(192, 159, 83, 0.85);\n    border-bottom: 1px solid rgba(192, 159, 83, 0.18);\n    white-space: nowrap;\n}\n\n.experiments-compact__table tbody td {\n    padding: 12px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n    vertical-align: middle;\n}\n\n.experiments-compact__table tbody tr:last-child td {\n    border-bottom: none;\n}\n\n.experiments-compact__table tbody tr:hover {\n    background: rgba(192, 159, 83, 0.06);\n}\n\n.experiments-compact__num {\n    text-align: right;\n    font-variant-numeric: tabular-nums;\n    white-space: nowrap;\n}\n\n.experiments-compact__variant-name {\n    font-weight: 600;\n    color: #f3f3f3;\n}\n\n.experiments-compact__tag {\n    display: inline-block;\n    margin-left: 8px;\n    padding: 2px 8px;\n    border-radius: 999px;\n    font-size: 10px;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    font-weight: 600;\n    background: rgba(96, 125, 139, 0.22);\n    color: #c2d1d9;\n    border: 1px solid rgba(96, 125, 139, 0.4);\n}\n\n.experiments-compact__tag--winning {\n    background: rgba(192, 159, 83, 0.22);\n    color: #f5d27a;\n    border-color: rgba(192, 159, 83, 0.5);\n}\n\n.experiments-compact__row--control td {\n    background: rgba(96, 125, 139, 0.06);\n}\n\n.experiments-compact__row--winning td {\n    background: rgba(192, 159, 83, 0.07);\n}\n\n.experiments-compact__sig {\n    display: inline-flex;\n    align-items: center;\n    padding: 3px 9px;\n    border-radius: 999px;\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    background: rgba(158, 158, 158, 0.14);\n    color: #c4c4c4;\n    border: 1px solid rgba(158, 158, 158, 0.3);\n    white-space: nowrap;\n}\n\n.experiments-compact__sig--win {\n    background: rgba(76, 175, 80, 0.18);\n    color: #8de08e;\n    border-color: rgba(76, 175, 80, 0.4);\n}\n\n.experiments-compact__sig--loss {\n    background: rgba(244, 67, 54, 0.18);\n    color: #ff8a80;\n    border-color: rgba(244, 67, 54, 0.4);\n}\n\n.experiments-compact__sig--warn {\n    background: rgba(255, 152, 0, 0.18);\n    color: #ffc97a;\n    border-color: rgba(255, 152, 0, 0.4);\n}\n\n.experiments-compact__sig--soft {\n    background: rgba(120, 144, 156, 0.18);\n    color: #b0bec5;\n    border-color: rgba(120, 144, 156, 0.32);\n}\n\n.experiments-compact__sig--control {\n    background: rgba(96, 125, 139, 0.22);\n    color: #c2d1d9;\n    border-color: rgba(96, 125, 139, 0.4);\n}\n\n/* ---------------------------------------------------------------- */\n/* Experiments list view — domain-scoped summary cards              */\n/* ---------------------------------------------------------------- */\n\n.experiments-list-intro-block {\n    flex: 1 1 320px;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.experiments-list-domain-pill {\n    display: inline-flex;\n    align-self: flex-start;\n    align-items: center;\n    padding: 3px 10px;\n    border-radius: 999px;\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    background: rgba(192, 159, 83, 0.16);\n    color: #f5d27a;\n    border: 1px solid rgba(192, 159, 83, 0.35);\n}\n\n.experiments-list-empty {\n    background: rgba(22, 22, 26, 0.55);\n    border: 1px dashed rgba(192, 159, 83, 0.25);\n    border-radius: 12px;\n    padding: 32px 28px;\n    text-align: center;\n    margin-top: 8px;\n}\n\n.experiments-list-empty__title {\n    font-size: 16px;\n    font-weight: 600;\n    color: #f3f3f3;\n    margin: 0 0 6px;\n}\n\n.experiments-list-empty__sub {\n    font-size: 13px;\n    color: #a4a4a8;\n    margin: 0;\n    line-height: 1.55;\n}\n\n.experiments-list-empty__sub code {\n    background: rgba(192, 159, 83, 0.12);\n    color: #f5d27a;\n    padding: 2px 6px;\n    border-radius: 4px;\n    font-size: 12px;\n}\n\n.experiments-list-grid {\n    list-style: none;\n    padding: 0;\n    margin: 8px 0 0;\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 14px;\n}\n\n.experiments-list-card-wrap {\n    list-style: none;\n}\n\n.experiments-list-card {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    padding: 18px 20px;\n    background: rgba(22, 22, 26, 0.6);\n    border: 1px solid rgba(192, 159, 83, 0.18);\n    border-radius: 12px;\n    text-decoration: none;\n    color: inherit;\n    transition: border-color 0.15s ease, transform 0.15s ease,\n        background 0.15s ease;\n    height: 100%;\n}\n\n.experiments-list-card:hover,\n.experiments-list-card:focus-visible {\n    border-color: rgba(192, 159, 83, 0.5);\n    background: rgba(34, 34, 40, 0.85);\n    transform: translateY(-1px);\n    outline: none;\n}\n\n.experiments-list-card__header {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.experiments-list-card__title {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 700;\n    color: #f3f3f3;\n    letter-spacing: -0.01em;\n    word-break: break-word;\n}\n\n.experiments-list-card__chips {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n}\n\n.experiments-list-card__chip {\n    display: inline-flex;\n    align-items: center;\n    padding: 3px 9px;\n    border-radius: 999px;\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    background: rgba(96, 125, 139, 0.18);\n    color: #c2d1d9;\n    border: 1px solid rgba(96, 125, 139, 0.35);\n}\n\n.experiments-list-card__chip--channel {\n    background: rgba(192, 159, 83, 0.16);\n    color: #f5d27a;\n    border-color: rgba(192, 159, 83, 0.4);\n}\n\n.experiments-list-card__chip--mixed {\n    background: rgba(120, 144, 156, 0.18);\n    color: #b0bec5;\n    border-color: rgba(120, 144, 156, 0.35);\n}\n\n.experiments-list-card__chip--untargeted {\n    background: rgba(158, 158, 158, 0.14);\n    color: #c4c4c4;\n    border-color: rgba(158, 158, 158, 0.3);\n}\n\n.experiments-list-card__chip--domain {\n    background: rgba(34, 34, 40, 0.95);\n    color: #ececec;\n    border-color: rgba(255, 255, 255, 0.12);\n}\n\n.experiments-list-card__metrics {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));\n    gap: 10px 14px;\n    margin: 0;\n}\n\n.experiments-list-card__metrics > div {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n}\n\n.experiments-list-card__metrics dt {\n    font-size: 10px;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    color: rgba(192, 159, 83, 0.85);\n    font-weight: 600;\n}\n\n.experiments-list-card__metrics dd {\n    margin: 0;\n    font-size: 15px;\n    font-weight: 700;\n    color: #f3f3f3;\n    line-height: 1.2;\n    font-variant-numeric: tabular-nums;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.experiments-list-card__leader {\n    display: inline-flex;\n    align-items: baseline;\n    gap: 6px;\n}\n\n.experiments-list-card__leader-rate {\n    font-size: 11px;\n    color: #8de08e;\n    font-weight: 600;\n}\n\n.experiments-list-card__cta {\n    margin-top: auto;\n    align-self: flex-start;\n    font-size: 12px;\n    font-weight: 600;\n    color: rgba(192, 159, 83, 0.9);\n    letter-spacing: 0.02em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
